import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import Image from "../Global/Image";

const GalleryMediaItem = (props) => {
  const { clickHandler, data } = props;

  return (
    <div
      className={`gallery-item h-100 brand-cursor d-flex justify-content-center align-items-center`}
      onClick={clickHandler}
      onKeyDown={clickHandler}
      role="button"
      tabIndex="-1"
    >
      {(data.video?.vimeo_raw || data.youtube) && data.image && (
        <div className="position-relative">
          <Image
            src={data?.image?.filename}
            alt={data?.image?.alt}
            sm="355x200"
            md="533x300"
            lg="0x650"
          />
          <FontAwesomeIcon
            className="position-absolute brand-text-white"
            style={{
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
            icon="play-circle"
          />
        </div>
      )}

      {!data.video?.vimeo_raw && !data.youtube && data.image && (
        <Image
          src={data?.image?.filename}
          alt={data?.image?.alt}
          sm="355x200"
          md="533x300"
          lg="0x650"
        />
      )}
    </div>
  );
};

export default GalleryMediaItem;
